/* ── FAQ accordion ── */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.js-faq-btn');
  if (!btn) return;
  var expanded = btn.getAttribute('aria-expanded') === 'true';
  var list = btn.closest('.faq-list') || document;
  list.querySelectorAll('.js-faq-btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  btn.setAttribute('aria-expanded', String(!expanded));
});

/* ── Cart count ── */
document.addEventListener('DOMContentLoaded', function () {
  var els = document.querySelectorAll('.gh-nav__cart-count');
  if (!els.length) return;
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (d) {
    els.forEach(function (c) {
      c.textContent = d.item_count;
      c.style.display = d.item_count ? 'flex' : 'none';
    });
  }).catch(function () {});
});

/* ── Scroll reveal ── */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function collect() { return document.querySelectorAll('[data-reveal]:not(.is-in)'); }
  if (reduce || !('IntersectionObserver' in window)) {
    collect().forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  function scan() {
    collect().forEach(function (el, i) {
      if (!el.style.getPropertyValue('--rd') && el.dataset.revealStagger !== 'off') {
        var sibs = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.setProperty('--rd', Math.min(sibs, 6) * 70 + 'ms');
      }
      io.observe(el);
    });
  }
  document.addEventListener('DOMContentLoaded', scan);
  if (document.readyState !== 'loading') scan();
})();

/* ── Header shrink on scroll ── */
(function () {
  var nav = document.querySelector('.gh-nav');
  if (!nav) return;
  var last = 0;
  function onScroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    nav.classList.toggle('is-scrolled', y > 24);
    last = y;
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* ── Mobile menu ── */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.gh-mobile-menu-btn');
    if (btn) {
      var drawer = document.getElementById('ghMobileDrawer');
      if (drawer) { drawer.classList.toggle('is-open'); document.body.classList.toggle('gh-no-scroll'); }
      return;
    }
    if (e.target.closest('.gh-drawer__close') || e.target.classList.contains('gh-drawer__backdrop')) {
      var d = document.getElementById('ghMobileDrawer');
      if (d) { d.classList.remove('is-open'); document.body.classList.remove('gh-no-scroll'); }
    }
  });
})();
